import React, { useEffect, useState } from "react";
import Api from "./api/api";
import Label from "./Label";
import TripleConfirmButton from "./TripleConfirmButton";
import { renderVariants, renderSubProducts } from "./functions/renderOrderVariants";
import "../css/OrderTicketsModal.css";

export default function PickupTickets({ orderId }) {
	const [tickets, setTickets] = useState([]);
	const [totalTickets, setTotalTickets] = useState(0);
	const [loading, setLoading] = useState(true);
	const [armedIndex, setArmedIndex] = useState(null);

	useEffect(() => {
		Api.post("/orders/get_tickets/" + orderId + "/").then((res) => {
			if (res.success === 1) {
				const initial = res.tickets.map((t) => ({
					...t,
					confirmed: t.products.every((p) => p.status === "filled"),
				}));
				setTickets(initial);
				setTotalTickets(res.total_tickets || res.tickets.length);
			}
			setLoading(false);
		});
	}, [orderId]);

	const confirmedCount = tickets.filter((t) => t.confirmed).length;

	const confirmPickup = async (centerIndex) => {
		const ticket = tickets[centerIndex];
		const res = await Api.postProtected("/orders/edit/" + orderId + "/", {
			status: "filled",
			production_center_ids: [ticket.production_center_id],
		});
		if (res.success !== 0) {
			setTickets((prev) =>
				prev.map((t, i) => (i === centerIndex ? { ...t, confirmed: true } : t))
			);
		}
	};

	if (loading) {
		return (
			<div className="pts-loading">
				<Label number={161} />
			</div>
		);
	}

	if (!tickets.length) return null;

	return (
		<div className="pickup-tickets">
			<div className="pts-header">
				<div className="pts-header-title">
					<Label number={157} />
				</div>
				<div className="pts-counter">
					{confirmedCount}/{totalTickets} <Label number={159} />
				</div>
			</div>
			<div className="pts-subtext">
				<Label number={158} />
			</div>
			<div className="pts-tickets">
				{tickets.map((ticket, i) => (
					<div
						key={ticket.production_center_id}
						className="ticket-card"
						style={{
							filter: ticket.confirmed ? "grayscale(1)" : "none",
							transition: "filter .4s ease",
						}}
					>
						<div
							className="ticket-header"
							style={{
								backgroundColor: ticket.confirmed
									? "#B9B9BD"
									: ticket.production_center_color || "var(--c1)",
							}}
						>
							<div className="ticket-header-left">
								<div>
									<div className="ticket-center-name">
										{ticket.production_center_name}
									</div>
									<div className="ticket-center-sub">Centro di produzione</div>
								</div>
							</div>
							<div className="ticket-badge">
								<span className="ticket-badge-label">TICKET</span>
								<span className="ticket-badge-number">
									{ticket.ticket_index}/{totalTickets}
								</span>
							</div>
						</div>

						<div className="ticket-body">
							{ticket.products.map((product, pi) => (
								<div key={pi} className="ticket-product">
									<span className="ticket-product-qty">{product.qty}×</span>
									<div className="ticket-product-name">
										{product.name}
										{renderVariants(product.variants)}
										{renderSubProducts(product.products)}
									</div>
								</div>
							))}
						</div>

						<div className="ticket-action">
							{ticket.confirmed ? (
								<div className="tcb-completed">
									<svg
										width="16"
										height="16"
										viewBox="0 0 24 24"
										fill="none"
										stroke="#6B6B70"
										strokeWidth="3"
										strokeLinecap="round"
										strokeLinejoin="round"
									>
										<path d="M20 6 9 17l-5-5" />
									</svg>
									<Label number={166} />
								</div>
							) : (
								<TripleConfirmButton
									onArm={() => setArmedIndex(i)}
									actionColor={ticket.production_center_color || "var(--c1)"}
								/>
							)}
						</div>

						{ticket.confirmed && (
							<div className="ticket-stamp-overlay">
								<div className="ticket-stamp">
									<Label number={166} />
								</div>
							</div>
						)}

						{armedIndex === i && (
							<div className="tcb-popup-overlay">
								<div className="tcb-popup">
									<div
										className="tcb-popup-icon"
										style={{
											background:
												(ticket.production_center_color || "#1F8A5B") + "1A",
										}}
									>
										<svg
											width="22"
											height="22"
											viewBox="0 0 24 24"
											fill="none"
											stroke={ticket.production_center_color || "#1F8A5B"}
											strokeWidth="2.2"
											strokeLinecap="round"
											strokeLinejoin="round"
										>
											<path d="M12 9v4M12 17h.01M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0Z" />
										</svg>
									</div>
									<div className="tcb-popup-title">
										<Label number={169} />
									</div>
									<div className="tcb-popup-sub">
										<Label number={170} />
									</div>
									<div className="tcb-popup-actions">
										<button onClick={() => setArmedIndex(null)}>
											<Label number={163} />
										</button>
										<button
											style={{
												background:
													ticket.production_center_color || "#1F8A5B",
											}}
											onClick={() => {
												setArmedIndex(null);
												confirmPickup(i);
											}}
										>
											<Label number={162} />
										</button>
									</div>
								</div>
							</div>
						)}
					</div>
				))}
			</div>
		</div>
	);
}
